import { render, staticRenderFns } from "./AttributionTable.vue?vue&type=template&id=9c2bab86&scoped=true"
import script from "./AttributionTable.vue?vue&type=script&lang=js"
export * from "./AttributionTable.vue?vue&type=script&lang=js"
import style0 from "./AttributionTable.vue?vue&type=style&index=0&id=9c2bab86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2bab86",
  null
  
)

export default component.exports